/*===================================
||
|| DropDownContext
||
===================================*/
import React, { createContext, useReducer, useMemo, useRef } from "react";
import PropTypes from "prop-types";

// store
import { reducer } from "./store";

// components
import MountingWrapper from "./components/MountingWrapper";
export { Hotspot } from "./components/Hotspot";
export { DropDown } from "./components/DropDown";

/*---------------------------
| Context
---------------------------*/
export const DropDownContext = createContext();
DropDownContext.displayName = "DropDown"; // Display Name

// Provider
export const DropDownProvider = ({
    children,
    hasCloseButton = false,
    hasTriangle = false,
    toggleOnHover = false,
    hideOnScroll = false,
    id,
    isDarkMode = false,
    isDisabled = false,
    alignment = "left", // left | center | right,
    top = 0,
    width = 300,
    padding = 30,
    zIndex = 1,
    onOpen = () => {},
    onClose = () => {}
}) => {
    const dropDownRef = useRef(null);

    const nonStateProps = {
        dropDownRef,
        hasCloseButton,
        toggleOnHover,
        hideOnScroll,
        id,
        hasTriangle,
        alignment,
        isDarkMode,
        width,
        top,
        padding,
        zIndex,
        onOpen,
        onClose,
        isDisabled
    };

    const stateProps = {
        isOpen: false,
        shouldFocus: false
    };

    // Whatever you want to manage as internal state
    const [state, dispatch] = useReducer(reducer, stateProps);

    // useMemo so it does not pass value on every render
    const value = useMemo(() => ({ state, dispatch, nonStateProps }), [
        state,
        dispatch,
        nonStateProps
    ]);

    return (
        <DropDownContext.Provider value={value}>
            <MountingWrapper>{children}</MountingWrapper>
        </DropDownContext.Provider>
    );
};

// prop-types
DropDownProvider.propTypes = {
    children: PropTypes.any,
    hasCloseButton: PropTypes.bool,
    hasTriangle: PropTypes.bool,
    toggleOnHover: PropTypes.bool,
    hideOnScroll: PropTypes.bool,
    id: PropTypes.string.isRequired,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    isDisabled: PropTypes.bool,
    isDarkMode: PropTypes.bool,
    alignment: PropTypes.oneOf(["left", "center", "right"]),
    top: PropTypes.number,
    width: PropTypes.number,
    padding: PropTypes.number,
    zIndex: PropTypes.number
};
